module.exports = __webpack_public_path__ + "img/DE05812.6aa36052.png";